import { productArticlesInfo } from '../../shared/news/productArticlesSettings';
import { useState } from 'react';

const ProductArticlesSection = (settings) => {
    const groupedArticles = productArticlesInfo.items.reduce((acc, item) => {
        if (!acc[item.product]) {
            acc[item.product] = [];
        }
        acc[item.product].push(item);
        return acc;
    }, {});

    const [activeProduct, setActiveProduct] = useState(Object.keys(groupedArticles)[0]);

    return (
        <div className="py-4 product-article-section">
            <div className="container">
                <div className="row">
                    <div className="col">
                        <span className='section-title-2'>Articles by product area</span>
                    </div>
                </div>
                <div className="row mt-3 g-0 d-flex align-items-stretch">
                    <ul className="nav nav-pills">
                        {Object.keys(groupedArticles).map((product, index) => (
                            <li key={index} className="nav-item">
                                <button
                                    className={`btn nav-link ${product === activeProduct ? 'active' : ''}`}
                                    onClick={() => setActiveProduct(product)}
                                >
                                    {product}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="row mt-3">
                    {groupedArticles[activeProduct].map((article, index) => (
                        <div key={index} className="col-md-6 mb-3 d-flex">
                            <a
                                href={article.url}
                                className="card flex-fill h-100 text-decoration-none text-reset"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ width: '100%' }}
                            >
                                <div className="card-body d-flex flex-column">
                                    <p className="card-text"><small className="text-muted">{article.date}</small></p>
                                    <h5 className="card-title">{article.header}</h5>
                                    <p className="card-text">{article.shortText}</p>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ProductArticlesSection;
